import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import axios from 'axios';

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openItems, setOpenItems] = useState(new Set());

  const fetchFAQs = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        language: i18n.language
      };
      
      const response = await axios.get('/api/faqs', { params });
      setFaqs(response.data);
      setError(null);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      setError(t('faq.errorLoading') || 'Error loading FAQs');
    } finally {
      setLoading(false);
    }
  }, [i18n.language, t]);

  useEffect(() => {
    fetchFAQs();
  }, [fetchFAQs]);

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <div className="faq-container">
      <div className="content-box">
        <h1>{t('faq.title') || 'FAQ'}</h1>
        <p className="faq-subtitle">
          {t('faq.subtitle') || 'Hier findest du Antworten auf die häufigsten Fragen zu togee.'}
        </p>

        {/* Back to Homepage Button for non-authenticated users */}
        {!isAuthenticated && (
          <div className="faq-back-button">
            <Link to="/login" className="btn btn-primary btn-full">
              {t('faq.backToHome') || 'Zurück zur Startseite'}
            </Link>
          </div>
        )}

        {/* Loading State */}
        {loading && (
          <div className="loading">
            {t('common.loading') || 'Lädt...'}
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {/* FAQ Items */}
        {!loading && !error && (
          <div className="faq-list">
            {faqs.length === 0 ? (
              <div className="no-results">
                <p>{t('faq.noFAQs') || 'Keine FAQs verfügbar.'}</p>
              </div>
            ) : (
              faqs.map((faq) => (
                <div key={faq.id} className="faq-item">
                  <button
                    className={`faq-question ${openItems.has(faq.id) ? 'active' : ''}`}
                    onClick={() => toggleItem(faq.id)}
                    aria-expanded={openItems.has(faq.id)}
                  >
                    <span className="faq-question-text">{faq.title}</span>
                    <span className="faq-toggle-icon">
                      {openItems.has(faq.id) ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div 
                    className={`faq-answer ${openItems.has(faq.id) ? 'open' : ''}`}
                  >
                    <div className="faq-answer-content">
                      {faq.content.split('\n').map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ; 